let setInformation = () => {
    /*  */
};
let clearInfo = () => {
    /* */
};

let addInfo = (info) => {
    setInformation(info);
};

let createInfo = (name, title, message, severity, redirectUrl) => {
    return { name, title, message, severity, redirectUrl, date: Date.now(), isRead: false };
};

let registerReducerVariables = (setInformationFunction, clearInfoFunction) => {
    setInformation = setInformationFunction;
    clearInfo = clearInfoFunction;
};

let clearInfoOnName = (name) => {
    if (name.length <= 0) {
        console.error('Attempted to Clear Info without name when one is required');
        return;
    }

    clearInfo(name);
};

let clearAll = () => {
    clearInfo('');
};

const LoggingUtilities = {
    Register: registerReducerVariables,
    CreateInfo: createInfo,
    Add: addInfo,
    Clear: clearInfoOnName,
    ClearAll: clearAll
};

export default LoggingUtilities;
